<template>
  <div class="card">
    <h5 class="card-header">Company/Division</h5>
    <div class="table-responsive">
      <table class="table">
        <thead>
          <tr>
            <th scope="col" class="border-top-0">Name</th>
            <th class="text-center border-top-0 enabled-header">
              Enabled
              <span data-toggle="tooltip" data-placement="top" title="This enables or disables the user from using this company/division.">
                <fa icon="question-circle" />
              </span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr colspan="12" v-if="!items.length" class="text-muted text-center">
            <td colspan="12">
              No companies/divisions
            </td>
          </tr>
          <tr v-for="item in items" :key="item.id">
            <td>
              <span class="pt-2" :class="item.status !== 'enabled' ? 'text-muted' : ''">{{ item.displayName }}</span>
            </td>
            <td class="text-center">
              <div class="custom-control custom-switch">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  :id="item.id"
                  :disabled="loadingMessage"
                  :checked="item.status === 'enabled'"
                  @change="toggle(item, $event)"
                />
                <label class="custom-control-label" :for="item.id"></label>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import $ from "jquery";

export default {
  props: {
    organizationId: String,
    userId: String,
  },
  data() {
    return {
      loadingMessage: null,
      error: null,

      items: [],
    };
  },
  created() {
    this.load();
  },
  mounted() {
    $('[data-toggle="tooltip"]').tooltip({ boundary: "window" });
  },
  watch: {
    organizationId() {
      this.load();
    },
    userId() {
      this.load();
    },
  },
  methods: {
    load() {
      this.loadingMessage = "Loading...";
      this.$axios
        .get(`/v1/organizations/${this.organizationId}/users/${this.userId}/companies`)
        .then(res => (this.items = res.data))
        .catch(() => this.$router.push(`/organizations/${this.organizationId}/users/${this.userId}`))
        .finally(() => (this.loadingMessage = null));
    },
    toggle(item, $event) {
      const payload = {
        status: $event.target.checked ? "enabled" : "disabled",
      };

      this.loadingMessage = "Saving...";
      this.$axios
        .put(`/v1/organizations/${this.organizationId}/users/${this.userId}/companies/${item.id}`, payload)
        .then(() => this.load())
        .catch(err => (this.error = err))
        .finally(() => (this.loadingMessage = null));
    },
  },
};
</script>

<style lang="scss" scoped>
.table-responsive {
  height: 400px;
  overflow-y: scroll;

  table {
    margin-bottom: 0;

    thead tr:nth-child(1) th {
      background: white;
      position: sticky;
      top: 0;
      z-index: 10;
    }

    .enabled-header {
      width: 115px;
    }
  }
}

.custom-control-label {
  cursor: pointer;
}
</style>
